import { useState } from 'react'
import { colors, fonts, glyphs } from '../../../Styles';
import { PrimaryPopover } from '../..';

interface EventNotePopover_Props {
  eventName: string
  eventNote?: string
  glyphColor?: colors
}
/**
 * EventNotePopover
 * @param selectedAnimal
 * @returns
 */
export default function EventNotePopover({eventName, eventNote, glyphColor}:EventNotePopover_Props) {
  const [, setIsOpen] = useState(false)

  return ( <>
    <PrimaryPopover
      content={ <div onClick={() => setIsOpen(true)} style={{width: "fit-content", height: "fit-content", margin: "-5px 0px", cursor: "pointer"}}>
        <glyphs.Note fillColor={glyphColor}/>
      </div> } 
      popoverHeader={eventName} 
      popoverContent={ <>
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minWidth: "130px"}}>
          <p style={{...fonts.fontSize4, ...fonts.paragraph, color: colors.greyLightTertiary, textAlign: "center"}}>{eventNote}</p>
        </div>
      </> } 
    />
  </> )
}